// © Microsoft Corporation. All rights reserved.
export const ContentPreview = {
    dbName: "wwContent",
    storeName: "Preview",
    indexName: "MyFeed"
};
export const SamAuctionCall = {
    dbName: "SamAdData",
    storeName: "SamAuction",
    indexName: "CallData"
};
// Used for ExP to improve Native Ads loading
export const ContentList = {
    dbName: "AdsContent",
    storeName: "CmsLists",
    indexName: "FallbackAds"
};
export const MyBriefing = {
    myBriefingServiceEndpoint: "/service/News/Briefing",
    defaultOcid: "Peregrine"
};
export const OneServiceMetadataType = {
    // infopane
    Infopane: "infopane",
    SportsMatch: "SportsMatch",
    WeatherSummary: "WeatherSummary",
    WeatherSummary_spotlight: "WeatherSummary_spotlight",
    TrafficDelays: "TrafficDelays",
    StockQuote: "StockQuote",
    ShoppingMerchantCategoryDeals: "ShoppingMerchantCategoryDeals",
    MyBriefRiverCard: "toppicks",
    TopStories: "topStories",
    Upsell: "Upsell"
};
//# sourceMappingURL=Constants.js.map